import { parseSwiftXML } from '../utils/swiftParser';
import { toast } from 'sonner';

export const useFileHandlers = (setPayments, setOriginalXmlContents, setError, routesInDb, handleFindBestRoute) => {
  const handleXmlUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      const xmlContent = e.target?.result;
      try {
        const parsedData = parseSwiftXML(xmlContent);
        
        if (parsedData.routes && parsedData.routes.length > 0) {
          setOriginalXmlContents([xmlContent]);
          
          const initialPayments = parsedData.routes.map(route => ({
            payment: route,
            optimalRoute: null,
            alternatesSent: 0
          }));
          
          setPayments(initialPayments);
          setError(null);
          
          const messageInfo = parsedData.messageCount > 1 
            ? `${parsedData.messageCount} SWIFT messages` 
            : 'SWIFT message';
          
          toast.success(`✓ Parsed ${messageInfo}! Found ${parsedData.routes.length} payment(s)`);
          
          if (routesInDb > 0) {
            toast.info('Auto-finding optimal routes...');
            setTimeout(() => handleFindBestRoute(initialPayments), 500);
          }
        } else {
          throw new Error('No routes found in SWIFT message');
        }
      } catch (err) {
        setError('Failed to parse SWIFT XML: ' + err.message);
        toast.error('Failed to parse SWIFT XML: ' + err.message);
      }
    };
    reader.onerror = () => {
      setError('Failed to read XML file');
      toast.error('Failed to read XML file');
    };
    reader.readAsText(file);
  };

  return { handleXmlUpload };
};
